export default __webpack_public_path__ + "img/primary_5.png";